import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ProfileStep from './ProfileStep';
import ValidationErrorMessage from '../../../shared/ValidationErrorMessage';
import Http from '../../../shared/http';
import toastr from 'toastr';
import get from 'lodash/get'

export default class RetirementBudgetStep extends ProfileStep {
  constructor(props) {
    super(props);
    this.state = {
      pristine: true,
      errorMessage: '',
      isSubmitting: false
    };
  }

  onNext = (e) => {
    e.preventDefault();
    let retirementBudget = document.getElementById('profile_monthly_retirement_budget').value;

    if (this.validate(retirementBudget)) {
      this.postResultsAndRedirect();
    } else {
      this.setState({
        pristine: false,
        errorMessage: `Retirement budget is not valid`
      });
    }
  }

  validate = (val) => {
    let isValid = val != null && val != '' && val > 0;

    return isValid;
  }

  handleChange = (e) => {
    e.preventDefault();

    if (!this.state.pristine && !this.validate(e.target.value)) {
      this.setState({ errorMessage: `Retirement budget is not valid` });
    } else {
      this.setState({ errorMessage: '' });
    }
  }

  postResultsAndRedirect() {
    let profile = {
      is_retired: this.props.stepConfig.isRetired,
      retirement_age: document.getElementById('profile_retirement_age').value,
      monthly_current_budget: document.getElementById('profile_current_monthly_expenses').value,
      monthly_retirement_budget: document.getElementById('profile_monthly_retirement_budget').value,
      gross_monthly_current_income: document.getElementById('profile_current_income').value,
    }

    let data = {
      profile
    };

    Http.request(`/clients/${this.props.stepConfig.clientId}/onboarding/profile/answers`, "POST", JSON.stringify(data)).then((response) => {
      if (response.ok) {
        return response.json().then((data) => {
          window.location = data.redirect_path;
        });
      } else {
        this.showErrorMessage("Your request failed, please try again.");
        this.setState({ isSubmitting: false });
      }
    }, function (error) {
      this.showErrorMessage("Sorry, a network error occured. Please try again.");
      this.setState({ isSubmitting: false });
    });
    this.setState({ isSubmitting: true });
  }

  showErrorMessage(message) {
    toastr.options.positionClass = 'toast-footer-small';
    toastr.warning(message);
  }

  onNextButton() {
    if (this.state.isSubmitting) {
      return <button className="button profile-step__button" disabled="true" onClick={this.onNext}>Loading...</button>;
    } else {
      return <button className="button profile-step__button qa-profile-retirement-budget" onClick={this.onNext} data-tracking="true" data-event-name="Profile Step Complete" data-event-details={`{"client_id": ${this.props.stepConfig.clientId}, "flow": "onboarding"}`}>Done</button>;
    }
  }

  render() {
    return (
      <div className="profile-step">
        <h1 className="profile-step__title">{`What is your retirement budget?`}</h1>
        <div className="profile-step__content">
          <p>You can complete a detailed retirement budget later to set a more accurate savings goal.</p>
          <form className="simple_form js-onboarding-form onboarding__form" id="edit_profile_3" acceptCharset="UTF-8" onSubmit={this.onNext}>
            <input name="utf8" type="hidden" value="✓" />
            <fieldset className="form__inputs">
              <div className={`form-input string required profile_monthly_retirement_budget has-floating-label is-half is-center profile_monthly_retirement_budget_wrapper ${this.state.errorMessage.length > 0 ? 'has-error' : ''}`}>
                <label className="form-control profile_monthly_retirement_budget">
                  <div className="form-control__label">
                    <span>Monthly retirement budget (today's terms)</span><abbr title="required">*</abbr>
                  </div>
                  <div className="form-control__input">
                    <input className="string required format-currency monthly-retirement-input"
                      required="required" aria-required="true" type="text"
                      onChange={this.handleChange}
                      defaultValue={this.props.stepConfig.netMonthlyRetirementBudget}
                      name="profile[monthly_retirement_budget]" id="profile_monthly_retirement_budget" />
                  </div>
                </label>
                <ValidationErrorMessage errorMessage={this.state.errorMessage} />
              </div>
            </fieldset>
          </form>
          <div className='flex flex-col gap-4 mr-12 xs:mr-auto xs:flex xs:flex-row'>
            {this.props.onBack && <button className="button button--secondary profile-step__button" onClick={this.onBack}>Back</button>}
            {this.onNextButton()}
          </div>
        </div>
      </div>
    )
  }
}
